// @flow

//
// FP
//
import S, { F } from '../../../../lib/trix-fp-fantasy';

// buildOpenSale :: Action -> Future Error Data
const buildOpenSale = (env: any): any => (data: any, container: any, meta?: any): any => (cfg: any): any => (action: any) => {
    return S.pipe([
        // Sale -> Future () Sale
        F.resolve,

        // Future Error Sale -> Future Error Sale
        S.map((sale: any) => {
            const actions: Array<any> = [];

            // PATCH: cleanup sale lines for better visual experience.
            // NOTE: this should be part of halui
            // const setSaleLineActionId = 'trix-web-plugin-wms-retail-sale.manageRetailSalePage.root.manageRetailSaleContainer.currentRetailSaleLinesTable';
            // actions.push(
            //     env.ducks.actions[setSaleLineActionId].data.setData({
            //         items: [],
            //         page: { size: 100, totalElements: 0, totalPages: 1, number: 0 }
            //     })
            // );

            // navigate to sale id
            env.relativeNavigateTo(`/${sale.id}`);

            // // find action to set sale into redux store
            // const setSaleActionId = 'trix-web-plugin-wms-retail-sale.manageRetailSalePage.root.manageRetailSaleContainer';
            // actions.push(
            //     env.ducks.actions[setSaleActionId].data.setData(sale)
            // );

            // complete execution with success
            actions.push(cfg.actions.operationExecuted_Success({}));

            return(actions);
        })

    ]) (data);
}

export default buildOpenSale;